import { reactive, ref } from "vue";

export const taskList = reactive(ref<{ [key: string]: Record<string|number, any> }>({}));

export function callAllTaskList(...args: any[]) {
    Object.keys(taskList.value).forEach(scrollId => {
        callTaskList?.(scrollId)?.(...args);
    })
}

export function callTaskList(scrollId: string) {
    return (...args: any[]) => {
        if (!taskList.value?.[scrollId]) return;

        Object.values(taskList.value?.[scrollId]).forEach(
            cb => {
                cb?.(...args);
            }
        )
    }
}

let componentId = 1;
export function addTask(cb: any, scrollId: string) {
    if (!taskList.value?.[scrollId]) {
        taskList.value[scrollId] = {};
    }
    taskList.value[scrollId][componentId] = cb;
    return componentId++;
}

export function removeTask(component_id: string, scrollId: string) {
    if (taskList.value?.[scrollId]?.[component_id]) {
        taskList.value[scrollId][component_id] = undefined;
    }
}
